import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { searchBoxStyles } from "./styles/styles.js";

const SearchField = ({ searchValue, setSearchValue, placeholderText }) => {
  return (
    <TextField
      value={searchValue}
      onChange={async (e) => {
        setSearchValue(e.target.value);
      }}
      placeholder={placeholderText}
      autoComplete="off"
      variant="outlined"
      sx={searchBoxStyles}
      slotProps={{
        input: {
          sx: {
            height: "38px",
            borderRadius: "8px",
          },
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "black" }} />
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default SearchField;
